<template>
  <div v-if="item">

    <div id="printable-cheque" style="display:none">
      <div class="cheque-paper">
        <div class="cheque-date">
          <div
              v-for="(char,index) in formattedDate"
              :key="index"
              class="date-box"
          >
            {{ char }}
          </div>
        </div>

        <div class="cheque-pay-to">
          {{ item.contact_profile_name }}
        </div>

        <div class="cheque-amount-words">
          <div class="line1">{{ amountLineOne }}</div>
          <div class="line2">{{ amountLineTwo }}</div>
        </div>

        <div class="cheque-amount-figures">
          {{ commaFormat(item.amount) }}
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>

import {computed, onMounted, inject, ref} from "vue"
import figureFormatter from "@/services/utils/figureFormatter"
import handleAccounting from '@/services/modules/accounting';
import {useRoute} from "vue-router";

const props = defineProps({
  item:Object
})

const showError = inject("showError")
const showSuccess = inject("showSuccess")
const emit = defineEmits(['close', 'onPrinted']);
const {commaFormat,currencyToWord} = figureFormatter()
const { updateChequeRegisterStatus } = handleAccounting();
const loading = ref(false);
const route = useRoute();

const formattedDate = computed(()=>{
  if(!props.item.cheque_date) return []
  const date = props.item.cheque_date.replaceAll("-","")
  const year = date.substring(0,4)
  const month = date.substring(4,6)
  const day = date.substring(6,8)
  return (day+month+year).split("")
})

const amountInWords = computed(()=>{
  if(!props.item.amount) return ""

  return currencyToWord(props.item.amount)
})

const amountLines = computed(() => {
  return splitAmountText(amountInWords.value, 40)
})

const amountLineOne = computed(() => amountLines.value[0])
const amountLineTwo = computed(() => amountLines.value[1])

const splitAmountText = (text, limit = 40) => {
  if (!text) return ['', '']

  if (text.length <= limit) return [text, '']

  let breakIndex = text.lastIndexOf(' ', limit)
  if (breakIndex === -1) breakIndex = limit

  const line1 = text.substring(0, breakIndex).trim()
  const line2 = text.substring(breakIndex).trim()

  return [line1, line2]
}

const printCheque = async ()=>{
  const content = document.getElementById("printable-cheque").innerHTML
  const iframe = document.createElement("iframe")
  iframe.style.position="absolute"
  iframe.style.width="0"
  iframe.style.height="0"
  iframe.style.border="0"
  document.body.appendChild(iframe)

  const doc = iframe.contentWindow.document

  doc.write(`
        <html>
        <head>
        <title>Cheque Print</title>
        <style>
        @page{
          size: A4;
          margin:0;
        }
        body{
          margin:0;
          padding:0;
        }
        .cheque-wrapper{
          position:absolute;
          top:0;
          left:0;
          width:190mm;
          height:89mm;
        }
        .cheque-paper{
          position:relative;
          width:190mm;
          height:89mm;
          font-family:Courier New;
        }
        .cheque-date{
          position:absolute;
          top:15mm;
          right:0;
          display:flex;
        }
        .date-box{
          width:5mm;
          height:6mm;
          margin-left:1mm;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:4mm;
        }
        .cheque-pay-to{
          position:absolute;
          top:32mm;
          left:28mm;
          width:120mm;
          font-size:3mm;
        }
        .cheque-amount-words{
          position:absolute;
          top:40mm;
          width:130mm;
          font-size:3mm;
          line-height:5mm;
        }
        .line1{
          margin-left:45mm;
        }
        .line2{
          margin-left:20mm;
          margin-top: 4mm;
        }
        .cheque-amount-figures{
          position:absolute;
          top:38mm;
          right:1mm;
          width:48mm;
          height:14mm;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:4mm;
        }
        </style>
      </head>

        <body>
        <div class="cheque-wrapper">
           ${content}
        </div>
        <script>
        window.onload=function(){
          window.focus()
          window.print()
        }
        <\/script>
       </body>
      </html>
     `)
  doc.close()

    if (props.item.status != 'issued') {
      emit('close');
      return
    }

    try {
      loading.value = true;
      const data = {
        company_id: route.params.companyId,
        account_head_id: props.item.account_head_id,
        note: 'Printed',
        status: 'printed'
      };
      const query = `?company_id=${route.params.companyId}`;
      const res = await updateChequeRegisterStatus(data, props.item.id, query);
      if(res.status) {
        showSuccess(res.message);
        emit('onPrinted');
      }
      if(!res.status) {
        showError(res.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      loading.value = false;
      emit('close');
    }
}

onMounted(()=>{
  printCheque()
})

</script>